import React from "react";
import { Routes, Route } from "react-router-dom";
import ListBookings from "../Components/Bookings/listBookings";
import ViewBooking from "../Components/Bookings/viewBooking";
import ListBookingsPaymentExec from "../Components/Bookings/listBookingsPaymentExec";
import ViewBookingsPaymentExec from "../Components/Bookings/viewBookingPaymentExecutive";

const BookingRoutes = () => {
  return (
    <Routes>
      <Route path="/bookings" element={<ListBookings></ListBookings>}></Route>
      <Route
        path="/bookings/view/:id"
        element={<ViewBooking></ViewBooking>}
      ></Route>
      <Route
        path="/bookings/payment-executive/view/:id"
        element={<ViewBookingsPaymentExec></ViewBookingsPaymentExec>}
      ></Route>
      <Route
        path="/bookings/payment_exec/:id"
        element={<ListBookingsPaymentExec></ListBookingsPaymentExec>}
      ></Route>
    </Routes>
  );
};

export default BookingRoutes;
